import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Offcanvas, Button } from "react-bootstrap";

interface NumberPadProps {
  show: boolean;
  onClose: Function;
  pointType: string;
  val: string;
}

export default function NumberPad({ show, onClose, pointType, val }: NumberPadProps) {
  const numberVal = Array.from(Array(10).keys());
  const [value, setValue] = useState<any>("");

  const appendVal = (item: any) => {
    const v = value + item;
    console.log({ value, v, item });
    if (v.split(".").length > 2) {
      return;
    }
    if (v.split(".")[0]?.length > 3) {
      return;
    }
    if (pointType == "0.1" && v.includes(".") && v.split(".")[1]?.length > 1) {
      console.log(pointType, value);
      return;
    }
    if (pointType == "0.01" && v.includes(".") && v.split(".")[1]?.length > 2) {
      console.log(pointType, value);
      return;
    }
    if (pointType == "1" && item === ".") {
      console.log(pointType, value);
      return;
    }
    setValue(value + item);
  };

  const removeLastVal = () => {
    let x = value.substring(0, value.length - 1);
    setValue(x);
  };

  useEffect(() => {
    console.log("pointType", pointType);
  }, [pointType]);

  useEffect(() => {
    setValue(val);
  }, [val]);

  return (
    <React.Fragment>
      <>
        {show && <div className="offcanvas-backdrop fade show"></div>}
        <Offcanvas
          show={show}
          onHide={() => onClose(value)}
          placement={"bottom"}
          backdrop={false}
          onBlur={() => onClose(value)}
        >
          <Offcanvas.Header className="canvusHeaderClr">
            <Offcanvas.Title>{value}</Offcanvas.Title>
            <div className="next-btn-inner">
              <button type="button" className="btn" onClick={() => onClose(value)}>
                Done
              </button>
            </div>
          </Offcanvas.Header>
          <Offcanvas.Body className="backgroundclr">
            <div id="pad">
              <div id="numpad">
                {numberVal &&
                  numberVal.length &&
                  numberVal.map((item: any) => (
                    <div className="button" id="number-field" key={item} onClick={() => appendVal(item)}>
                      {item}
                    </div>
                  ))}
                <div className="button disables-button" onClick={() => appendVal(".")}>
                  .
                </div>
                <div className="button" id="number-field" onClick={removeLastVal}>
                  <i className="fa fa-arrow-left" aria-hidden="true" />
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </>
    </React.Fragment>
  );
}
